module.exports = __webpack_public_path__ + "static/media/stq.899670d5.svg";